import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput
} from "@met/react-components";
import { useState } from "react";

const UpdateTerminalModal = ({isLoading, onClose, isOpen, terminal, onTerminalUpdate }) => {
  const [terminalName, setTerminalName] = useState('');

  const handleUpdate = () => {
    if (!terminal?.locationId) return;

    const update = {
      ...terminal,
      terminalName: terminalName,
    };

    onTerminalUpdate(update);
    setTerminalName('');
  };

  const handleClose = () => {
    setTerminalName('');
    onClose();
  }

  return (
    <Modal hidden={!isOpen} >
      <ModalContent>
        <ModalHeader>
          Update Terminal: {terminal?.terminalName}
        </ModalHeader>
        <ModalBody>
          <TextInput 
            value={terminalName} 
            onChange={(e)=>setTerminalName(e.target.value)} 
            valid={terminalName?.length > 0} 
            placeholder={terminal?.terminalName || ''} 
          />
        </ModalBody>
        <ModalFooter>
          <Button 
            onClick={handleUpdate} 
            loading={isLoading} 
            style={{marginLeft: '5px'}} 
            primary disabled={!terminalName?.length > 0 || terminal?.terminalName === terminalName}
          >
              Ok
          </Button>
          <Button onClick={handleClose} secondary style={{marginLeft: '5px'}} loading={isLoading}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};

export default UpdateTerminalModal;